/* ============================================================
   KZ Restock Notify — back-in-stock lead capture.
   Posts directly to Shopify's customer endpoint via fetch using
   the same fields {% form 'customer' %} would emit. We do NOT
   use a real <form>, because the snippet renders inside the
   product cart-add form and HTML forbids nested forms (the inner
   one is silently dropped, so submits leak to /cart/add).
   ============================================================ */
(function () {
  'use strict';

  function bind(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    var input = root.querySelector('input[type="email"]');
    var button = root.querySelector('.kz-restock-notify__button');
    if (!input || !button) return;

    function submit() {
      if (!input.checkValidity()) {
        input.reportValidity();
        return;
      }

      var originalLabel = button.textContent;
      button.disabled = true;
      button.textContent = '…';

      var body = new FormData();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', input.value);
      body.append('contact[tags]', root.dataset.restockTags || 'restock-notify');

      fetch('/contact', { method: 'POST', body: body, headers: { 'Accept': 'text/html' } })
        .then(function (response) {
          if (!response.ok && response.status !== 302) {
            throw new Error('Subscribe failed (' + response.status + ')');
          }
          root.dataset.success = 'true';
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = originalLabel;
        });
    }

    button.addEventListener('click', submit);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        submit();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-restock-notify]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
